module.exports = __webpack_public_path__ + "static/media/NZFCDlogo.d60dffb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NZFCDlogo.png
// module id = 843
// module chunks = 0